/**
 * Fivans product card helpers — local wishlist toggle
 */
(function () {
  const STORAGE_KEY = 'fivans-wishlist-ids';

  function readIds() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function writeIds(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
      /* ignore quota / private mode */
    }
  }

  function syncButtons(ids) {
    document.querySelectorAll('[data-wishlist-id]').forEach((btn) => {
      const id = String(btn.getAttribute('data-wishlist-id'));
      const active = ids.includes(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function onClick(event) {
    const btn = event.target.closest('[data-wishlist-id]');
    if (!btn) return;

    event.preventDefault();
    const id = String(btn.getAttribute('data-wishlist-id'));
    let ids = readIds();

    if (ids.includes(id)) {
      ids = ids.filter((item) => item !== id);
    } else {
      ids.push(id);
    }

    writeIds(ids);
    syncButtons(ids);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('DOMContentLoaded', () => syncButtons(readIds()));
  syncButtons(readIds());
})();
